<template>
  <div  :style='{width: panelWidth}' >
    <el-table v-if="!showNetExposure" :key="'book-' + tableKey" ref='bookpnltable' :data='tableData' class='riskTable' :height="panelHeight" style='width: 100%' fit
        :cell-class-name = "() => 'lu-click'"
        :row-class-name="tableRowClassName"
        @row-dblclick='(row,column) => getDetail(row.instrumentName,row,column)'
        @sort-change='sortChange'
      >
      <el-table-column prop='instrumentName' ref='col1' sortable='custom' :dataKeys="['instrumentName']" sortFieldFormat="String" />
      <el-table-column align='center' :label="getCurrentBookLabel" v-if="showBook && bookBrokerList.length">
        <el-table-column align='center' v-for='broker in bookBrokerList' :key='broker.name' :label='broker.name'>
          <el-table-column align='center' v-for='book in broker.bookList' :key='book' :label='book' ref='col2' sortable='custom' :dataKeys="['book',broker.name,book]" sortFieldFormat="Number" >
            <template slot-scope="data">
              <template v-if='data.row.book[broker.name] && data.row.book[broker.name][book]'>
                <div style='text-align: right' :class='cellClass(data.row.book[broker.name][book])'>{{ data.row.book[broker.name][book] | formatAmount(bookPnLMode) }}</div>
              </template>
              <template v-else>
                <div style='text-align: right' class='positive'>{{ 0 | formatAmount(bookPnLMode) }}</div>
              </template>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table-column>
      <el-table-column v-if='showBook' width="100" align='center' :label='$t("Total Books")' prop='bookTotal' ref='col3' sortable='custom' :dataKeys="['bookTotal']" sortFieldFormat="Number">
        <template slot="header">
          <div>{{ $t('Total') }}</div>
          <div>{{ $t('Books') }}</div>
        </template>
        <template slot-scope="data">
          <div style='text-align: right' :class='cellClass(data.row.bookTotal)'>{{ data.row.bookTotal | formatAmount(bookPnLMode) }}</div>
        </template>
      </el-table-column>
      <el-table-column align='center' :label='$t("Hedging")' v-if="showBook && hedgingBrokerList.length">
        <el-table-column align='center' v-for='broker in hedgingBrokerList' :key='broker.name' :label='broker.name'>
          <el-table-column align='center' v-for='book in broker.bookList' :key='book' :label='book' ref='col4' sortable='custom' :dataKeys="['hedging',broker.name,book]" sortFieldFormat="Number" >
            <template slot-scope="data">
              <template v-if='data.row.hedging[broker.name] && data.row.hedging[broker.name][book]'>
                <div style='text-align: right' :class='cellClass(data.row.hedging[broker.name][book])'>{{ data.row.hedging[broker.name][book] | formatAmount(bookPnLMode) }}</div>
              </template>
              <template v-else>
                <div style='text-align: right' class='positive'>{{ 0 | formatAmount(bookPnLMode) }}</div>
              </template>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table-column>
      <el-table-column v-if='showBook && bookPnLMode' width="100" align='center' :label='$t("Hdg %")' prop='hedgingPercent' ref='col5' sortable='custom' :dataKeys="['hedgingPercent']" sortFieldFormat="Number">
        <template slot-scope="data">
          <div style='text-align: right' :class='cellClass(data.row.hedgingPercent)'>{{ data.row.hedgingPercent | formatPercentWithPrecision(0,bookPnLMode) }}</div>
        </template>
      </el-table-column>
      <el-table-column v-if='showBook && includeMarkupsVal && !bookPnLMode' align='center' :label='$t("Markup")' prop='markupAmount' ref='col6' sortable='custom' :dataKeys="['markupAmount']" sortFieldFormat="Number">
        <template slot-scope="data">
          <div style='text-align: right' :class='cellClass(data.row.markupAmount)'>{{ data.row.markupAmount | formatAmount(bookPnLMode) }}</div>
        </template>
      </el-table-column>
      <el-table-column align='center' :label='$t("Total")' prop='total' v-if="showBook" ref='col7' sortable='custom' :dataKeys="['total']" sortFieldFormat="Number">
        <template slot-scope="data">
          <div v-if='bookPnLMode && data.row && data.row.instrumentName === "Instrument"'>
            <el-tooltip :effect='styleTooltip'>
              <div slot="content">
                <lu-vbox v-for='cat in categoryList' :key='cat.categoryName'>
                  <lu-hbox class='tooltip'>
                    <lu-item lu-flex class='itemTitle'>{{ cat.categoryName }} :</lu-item>
                    <lu-item class='itemValue' :class='cellClass(cat.exposure)'>{{ cat.exposure | formatAmount }}</lu-item>
                  </lu-hbox>
                </lu-vbox>
              </div>
              <div style='text-align: right' :class='cellClass(data.row.total)'>{{ data.row.total | formatAmount(bookPnLMode) }}</div>
            </el-tooltip>
          </div>
          <div v-else-if='data.row && data.row.instrumentName !== "Instrument"'>
            <el-tooltip :effect='styleTooltip'>
              <div slot="content">
                <lu-hbox class='tooltip'>
                  <lu-item lu-flex class='itemTitle'>{{ $t('VWAP') }} :</lu-item>
                  <lu-item class='itemValue'>{{ data.row.vwap | formatRate(6) }}</lu-item>
                </lu-hbox>
              </div>
              <div style='text-align: right' :class='cellClass(data.row.total)'>{{ data.row.total | formatAmount(bookPnLMode) }}</div>
            </el-tooltip>
          </div>
          <div v-else>
            <div style='text-align: right' :class='cellClass(data.row.total)'>{{ data.row.total | formatAmount(bookPnLMode) }}</div>
          </div>
        </template>
      </el-table-column>
      <el-table-column align='center' :label="getCurrentSTPLabel" v-if="showSTP">
        <el-table-column align='center' v-for='broker in stpBrokerList' :key='broker' :label='broker' ref='col8' sortable='custom' :dataKeys="['stp',broker]" sortFieldFormat="Number">
          <template slot-scope="data">
            <div style='text-align: right' :class='cellClass(data.row.stp[broker])'>{{ data.row.stp[broker] | formatAmount(bookPnLMode) }}</div>
          </template>
        </el-table-column>
        <el-table-column align='center' :label='$t("Total")' prop='stp.total' ref='col9' sortable='custom' :dataKeys="['stp','total']" sortFieldFormat="Number">
          <template slot-scope="data">
            <div style='text-align: right' :class='cellClass(data.row.stp.total)'>{{ `${data.row.stp.total | formatAmount(bookPnLMode)} %` }}</div>
          </template>
        </el-table-column>
      </el-table-column>
    </el-table>

    <el-table
      v-if="showNetExposure"
      :key="'net-' + tableKey"
      ref='netexposuretable'
      class='riskTable'
      :cell-class-name = "() => 'lu-click'"
      :data="extraDataList"
      :height="panelHeight"
      fit
      style="width: 100%;"
      :row-class-name="tableRowClassName"
    >
      <el-table-column :label="$t('Symbol Net')" prop='instrument' align="center" />
      <el-table-column :label="$t('Symbol')" prop='symbol' align="center" />
      <el-table-column :label="exposure1Label" prop='exposure1' :sort-method='(a,b) => sortFloat(a,b,"exposure1")' align="center">
        <template slot-scope="scope">
          <div style='text-align: center' :class='scope.row.exposure1 >= 0  ? "positive" : "negative"'>{{ scope.row.exposure1 | formatAmount(true) }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="exposure2Label" prop='exposure2' :sort-method='(a,b) => sortFloat(a,b,"exposure2")' align="center">
        <template slot-scope="scope">
          <div style='text-align: center' :class='scope.row.exposure2 >= 0  ? "positive" : "negative"'>{{ scope.row.exposure2 | formatAmount(true) }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="exposure3Label" prop='exposure3' :sort-method='(a,b) => sortFloat(a,b,"exposure3")' align="center">
        <template slot-scope="scope">
          <div style='text-align: center' :class='scope.row.exposure3 >= 0  ? "positive" : "negative"'>{{ scope.row.exposure3 | formatAmount(true) }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Total Net')" prop='TotalCash' :sort-method='(a,b) => sortFloat(a,b,"TotalCash")' align="center">
        <template slot-scope="scope">
          <div style='text-align: center' :class='scope.row.TotalCash >= 0  ? "positive" : "negative"'>{{ scope.row.TotalCash | formatAmount(true) }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Total Net in future size')" prop='netFuturesExposure' :sort-method='(a,b) => sortFloat(a,b,"netFuturesExposure")' align="center">
        <template slot-scope="scope">
          <div style='text-align: center' :class='scope.row.netFuturesExposure >= 0  ? "positive" : "negative"'>{{ scope.row.netFuturesExposure | formatAmount(true) }}</div>
        </template>
      </el-table-column>
      <el-table-column :label="$t('Hedging %')" prop='hedgingPercent' align="center" />
    </el-table>

    <el-drawer :append-to-body="true" ref="bookConfigDrawer" :title="$t('Book Config')" :visible.sync="showDialog" direction="rtl" size="88%" destroy-on-close :before-close="handleClose" :modal="false">
      <div class="handle-button-close" @click='closeDialog'>
        <i class="el-icon-close" />
      </div>
      <book-config activeTab="books" />
    </el-drawer>
  </div>
</template>

<script>
import { LuVbox, LuHbox, LuItem } from 'lusis-ui'
import elDragDialog from '@/directive/el-dragDialog'
import BookConfig from './components/bookConfig'
import utils from '@/utils/formatNumber'
import { timestamp } from '@/utils'
import Debouncer from '@/utils/debounce.js'
import monitoringMixin from './mixins'
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'BookPnL',
  directives: { elDragDialog },
  props: [ 'data', 'panel', 'extraData' ],
  mixins: [ monitoringMixin ],
  components: { LuVbox, LuHbox, LuItem, BookConfig },
  filters: {
    formatAmount (value, bookPnLMode) {
      if (!value) {
        return utils.formatAmount(0, 2, 3, bookPnLMode)
      }
      return utils.formatAmount(value, 2, 3, bookPnLMode)
    },
    // formatPercent: function (value) {
    //   return (value || 0) + ' %'
    // },
    formatPercentWithPrecision: function (value, prec = 2, bookPnLMode) {
      let val = utils.formatNumber(value, prec, '.', '\u00a0', bookPnLMode)
      if (val !== '') {
        val = (val || 0) + ' %'
      }
      return val
      // return (utils.formatNumber(value, prec) || 0) + ' %'
    },
    formatRate: function (value, prec) {
      value = value || 0
      let idx = ('' + value).indexOf('.')
      if (idx !== -1) prec = value.length - idx - 1
      return utils.formatNumber(value, prec)
    }
  },
  data: function () {
    return {
      showDialog: false,
      stpBrokerList: [],
      bookBrokerList: [],
      hedgingBrokerList: [],
      categoryList: [],
      tableData: [],
      showBook: true,
      showSTP: false,
      currentFilter: { },
      tableKey: 0,
      debouncer: new Debouncer(),
    }
  },
  watch: {
    data: {
      handler (value) {
        // let data = this.parseData(value)
        // this.stpBrokerList = data.stpBrokerList
        // this.bookBrokerList = data.bookBrokerList
        // this.tableData = data.tableData
        this.updateData(value)
      },
      immediate: true
    }
  },
  computed: {
    ...mapGetters([ 'theme' ]),
    ...mapState({ includeMarkupsVal: state => state.settingsMonitor.settingParams.includeMarkups, panelConfig: state => state.settingsMonitor.settingParams.panelConfig }),
    excelColumns () {
      let columns = []
      for (let i = 0; i < 26; i++) {
        columns.push(String.fromCharCode(0x41 + i))
      }
      for (let i = 0; i < 26; i++) {
        for (let j = 0; j < 26; j++) {
          columns.push(String.fromCharCode(0x41 + i) + String.fromCharCode(0x41 + j))
        }
      }
      return columns
    },
    bookPnLMode: function () {
      let tmp = this.panelConfig.find(item => item.id === this.panel.id)
      return tmp ? tmp.options.bookPnLMode : 0
    },
    showNetExposure: function () {
      let tmp = this.panelConfig.find(item => item.id === this.panel.id)
      return tmp ? tmp.options.showNetExposure : false
    },
    getCurrentSTPLabel() {
      return this.getSTPLabel(this.bookPnLMode)
    },
    getCurrentBookLabel() {
      return this.getBookLabel(this.bookPnLMode)
    },
    getCurrentDataField() {
      return this.getDataField(this.bookPnLMode)
    },
    getLotsMios: function () {
      let tmp = this.panelConfig.find(item => item.id === this.panel.id)
      return !!tmp.options.lotsMios && tmp.options.lotsMios === 'lots' ? 'lots' : 'mios'
    },
    styleTooltip: function () {
      return this.theme !== 'light-theme' ? 'dark' : 'light'
    },
    extraDataList() {
      if (this.extraData && this.extraData.instrumentList) {
        return this.extraData.instrumentList
      }
      return []
    },
    exposure1Label () {
      return (this.extraData && this.extraData.value1) ? this.extraData.value1 : 'Exposure 1'
    },
    exposure2Label () {
      return (this.extraData && this.extraData.value2) ? this.extraData.value2 : 'Exposure 2' 
    },
    exposure3Label () {
      return (this.extraData && this.extraData.value3) ? this.extraData.value3 : 'Exposure 3' 
    }
  },
  methods: {
    sortChange: function(data) {
      const { column, order } = data

      // let currentCol = this.getColumns().find(item => item.columnId === column.id)
      let currentCol = this.getColumn(column.id)

      let dataKeys = []
      let sortFieldFormat = ""
      if (currentCol && currentCol.hasOwnProperty('$attrs')) {
        dataKeys = currentCol.$attrs.dataKeys
        sortFieldFormat = currentCol.$attrs.sortFieldFormat
      }

      this.currentFilter = { dataKeys, sortFieldFormat, order }
      this.dataSort()
    },
    getColumn: function(columnId) {
      return !this.showNetExposure ? this.getColumns().find(item => item.columnId === columnId) : null
    },
    getColumns: function() {
      let columns = []
      for (let ref of ["col1", "col2", "col3", "col4", "col5", "col6", "col7", "col8", "col9"]) {
        if (this.$refs[ref]!==null && this.$refs[ref]!==undefined) {
          if (Array.isArray(this.$refs[ref])) {
            columns = columns.concat(this.$refs[ref])
          } else {
            columns.push(this.$refs[ref])
          }
        }
      }
      return columns
    },
    dataSort: function() {
      let { dataKeys, sortFieldFormat, order } = this.currentFilter
      if (!(Boolean(dataKeys) && Boolean(order))) {
        // default
        dataKeys = ['total']
        sortFieldFormat = 'Number'
        order = 'descending'
        this.currentFilter = { dataKeys, sortFieldFormat, order }
      }
      this.tableData.sort(this.sortBy(dataKeys,sortFieldFormat,order))
    },
    sortBy: function(dataKeys,sortFieldFormat,order) {
      return function(a,b) {
        let value = 0

        const getPropValue = (data,dataKeys,sortFieldFormat) => {
          let currentData = data
          for (let key of dataKeys) {
            if (currentData!==null && currentData!==undefined && currentData.hasOwnProperty(key)) {
              currentData = currentData[key]
            }
          }
          if (typeof currentData === "object") {
            if (sortFieldFormat === 'String') {
              currentData = ''
            } else if (sortFieldFormat === 'Number') {
              currentData = 0
            } else {
              currentData = 0
            }
          }

          //format
          if (sortFieldFormat === 'String') {
            value = currentData.toUpperCase() 
          } else if (sortFieldFormat === 'Number') {
            if (!currentData) {
              currentData = 0
            }
            value = Math.abs(parseFloat(currentData))
          }
          return value
        }

        let valueA = getPropValue(a,dataKeys,sortFieldFormat)
        let valueB = getPropValue(b,dataKeys,sortFieldFormat)

        // //ref
        if (a.instrumentName==='Instrument') {
          return -1
        }
        if (b.instrumentName==='Instrument') {
          return 1
        }

        if (valueA>valueB) {
          // return 1
          return order==='ascending' ? 1 : -1
        }
        else if (valueA<valueB) {
          // return  -1
          return order==='ascending' ? -1 : 1
        }

        return 0
      }
    },
    updateData(value) {
      let data = this.parseData(value)
      this.stpBrokerList = data.stpBrokerList
      this.bookBrokerList = data.bookBrokerList
      this.hedgingBrokerList = data.hedgingBrokerList
      this.categoryList = data.categoryList
      this.tableData = data.tableData
      this.dataSort()
      this.updateLayout()
    },
    // updateLayout() {
    //   this.tableKey++
    //   this.$nextTick(() => {
    //     setTimeout(() => {
    //       const tableRef = this.showNetExposure ? 'netexposuretable' : 'bookpnltable';
    //       const table = this.$refs[tableRef];
    //       if (table && typeof table.doLayout === 'function') {
    //         table.doLayout();
    //       }
    //     }, 100);
    //   });
    // },
    updateLayout() {
      this.debouncer.debounce(200, function () {
        this.tableKey++
        const tableRef = this.showNetExposure ? 'netexposuretable' : 'bookpnltable';
        const table = this.$refs[tableRef];
        if (table && typeof table.doLayout === 'function') {
          table.doLayout();
        }
      }.bind(this))
    },
    getSTPLabel(bookPnLMode) {
      if (bookPnLMode) {
        return this.$t('STP Position')
      } else {
        return this.$t('STP PnL')
      }
    },
    getBookLabel(bookPnLMode) {
      if (bookPnLMode) {
        return this.$t('Book Position')
      } else {
        return this.$t('Book PnL')
      }
    },
    getDataField(bookPnLMode) {
      if (bookPnLMode) {
        if (this.getLotsMios === 'lots') {
          return 'numberOfLot'
        } else {
          return 'exposure'
        }
      } else {
        return 'profitAndLoss' 
      }
    },
    getExcelSheetName(bookPnLMode) {
      let tmp = this.panelConfig.find(item => item.id === this.panel.id)
      let exportExcelFilePrefix = tmp ? tmp.exportExcelFilePrefix : ""

      if (bookPnLMode) {
        return `${exportExcelFilePrefix} ${this.$t('Book Exposure')}`
      } else {
        return `${exportExcelFilePrefix} ${this.$t('Book PnL')}`
      }
    },
    parseData (value, bookPnLMode = this.bookPnLMode) {
      let stpBrokerList = []
      let bookBrokerList = []
      let hedgingBrokerList = []
      let categoryList = []
      let tableData = []
      let stpHash = {}
      let bookHash = {}
      let hedgingHash = {}
      if (value && value.length) {
        value.forEach(item => {
          let row = {
            instrumentName: item.instrumentName,
            label: item.label,
            stp: {},
            book: {},
            hedging: {},
            hedgingPercent: '',
            markupAmount: '',
            total: '',
            vwap: '',
            bookTotal: ''
          }
          if (item && item.roleList && item.roleList.length) {
            item.roleList.forEach(role => {
              if (role.title === 'TOTAL' && this.showBook) {
                if (role.hasOwnProperty(this.getDataField(bookPnLMode))) {
                  row.total = role[this.getDataField(bookPnLMode)]
                } else {
                  row.total= "0.00"
                }
                // row.total = role.profitAndLoss
                row.hedgingPercent = role.hedgingPercent
                row.markupAmount = role.markupAmount
                row.vwap = role.vwap

                if (item.instrumentName === 'Instrument' && role.categoryList && role.categoryList.length) {
                  categoryList = role.categoryList
                }
              }
              else if (role.title === 'BOOKTOTAL' && this.showBook) {
                if (role.hasOwnProperty(this.getDataField(bookPnLMode))) {
                  row.bookTotal = role[this.getDataField(bookPnLMode)]
                } else {
                  row.bookTotal= "0.00"
                }
              }
              else if (role.title === 'STP' && this.showSTP) {
                if (role.hasOwnProperty(this.getDataField(bookPnLMode))) {
                  row.stp.total = role[this.getDataField(bookPnLMode)]
                } else {
                  row.stp.total = "0.00"
                }
                // row.stp.total = role.profitAndLoss
                if (role.brokerList && role.brokerList.length) {
                  role.brokerList.forEach(broker => {
                    if (!stpHash[broker.brokerName]) {
                      stpHash[broker.brokerName] = stpBrokerList.length + 1
                      stpBrokerList.push(broker.brokerName)
                    }
                    if (broker.hasOwnProperty(this.getDataField(bookPnLMode))) {
                      row.stp[broker.brokerName] = broker[this.getDataField(bookPnLMode)]
                    } else {
                      row.stp[broker.brokerName] = "0.00"
                    }
                    // row.stp[broker.brokerName] = broker.profitAndLoss
                  })
                }
              }
              else if (role.title === 'BOOK' && this.showBook) {
                if (role.brokerList && role.brokerList.length) {
                  role.brokerList.forEach(broker => {
                    if (!bookHash[broker.brokerName]) {
                      bookHash[broker.brokerName] = {
                        pos: bookBrokerList.length,
                        bookHash: {}
                      }
                      bookBrokerList.push({
                        name: broker.brokerName,
                        bookList: []
                      })
                    }
                    row.book[broker.brokerName] = {}
                    if (broker && broker.dossierList && broker.dossierList.length) {
                      broker.dossierList.forEach(book => {
                        if (!bookHash[broker.brokerName].bookHash[book.dosName]) {
                          bookHash[broker.brokerName].bookHash[book.dosName] = bookBrokerList[bookHash[broker.brokerName].pos].bookList.length + 1
                          bookBrokerList[bookHash[broker.brokerName].pos].bookList.push(book.dosName)
                        }
                        if (book.hasOwnProperty(this.getDataField(bookPnLMode))) {
                          row.book[broker.brokerName][book.dosName] = book[this.getDataField(bookPnLMode)]
                        } else {
                          row.book[broker.brokerName][book.dosName] = "0.00"
                        }
                        // row.book[broker.brokerName][book.dosName] = book.profitAndLoss
                      })
                    }
                  })
                }
              }
              else if (role.title === 'HEDGING' && this.showBook) {
                if (role.brokerList && role.brokerList.length) {
                  role.brokerList.forEach(broker => {
                    if (!hedgingHash[broker.brokerName]) {
                      hedgingHash[broker.brokerName] = {
                        pos: hedgingBrokerList.length,
                        hedgingHash: {}
                      }
                      hedgingBrokerList.push({
                        name: broker.brokerName,
                        bookList: []
                      })
                    }
                    row.hedging[broker.brokerName] = {}
                    if (broker && broker.dossierList && broker.dossierList.length) {
                      broker.dossierList.forEach(book => {
                        if (!hedgingHash[broker.brokerName].hedgingHash[book.dosName]) {
                          hedgingHash[broker.brokerName].hedgingHash[book.dosName] = hedgingBrokerList[hedgingHash[broker.brokerName].pos].bookList.length + 1
                          hedgingBrokerList[hedgingHash[broker.brokerName].pos].bookList.push(book.dosName)
                        }
                        if (book.hasOwnProperty(this.getDataField(bookPnLMode))) {
                          row.hedging[broker.brokerName][book.dosName] = book[this.getDataField(bookPnLMode)]
                        } else {
                          row.hedging[broker.brokerName][book.dosName] = "0.00"
                        }
                      })
                    }
                  })
                }
              }
            })
          }
          tableData.push(row)
        })
      }
      return {
        stpBrokerList: stpBrokerList,
        bookBrokerList: bookBrokerList,
        hedgingBrokerList: hedgingBrokerList,
        categoryList: categoryList,
        tableData: tableData
      }
    },
    onSettings () {
      this.showDialog = !this.showDialog
    },
    onChangeBookPnLMode () {
      this.updateData(this.data)
    },
    onChangeLotsMios () {
      this.updateData(this.data)
    },
    onChangeShowNetExposure () {
      this.updateLayout()
    },
    handleClose(done) {
      this.showDialog = false
      setTimeout(() => {
        done();
        // animation takes time
        setTimeout(() => {
        }, 400);
      }, 600);
    },
    closeDialog () {
      if (this.$refs.bookConfigDrawer)
        this.$refs.bookConfigDrawer.closeDrawer()
    },
    cellClass (value) {
      return value < 0 ? 'negative' : 'positive'
    },
    handleDownload (dataList, sheetOnly) {
      return import('@/vendor/Export2Excel').then(excel => {
        let sheetList = []
        const columns = this.excelColumns

        for (let bookPnLMode of [0,1]) {
          let data = this.parseData(dataList,bookPnLMode)

          // let headers = [
          //   [ this.$t('Instrument') ],
          //   [ this.$t('Instrument') ],
          //   [ this.$t('Instrument') ],
          // ]
          let headers = [
            [ '' ],
            [ '' ],
            [ '' ],
          ]

          let merges = [ 'A1:A3' ]

          let col = 1

          let start = col

          // Book
          if (this.showBook) {
            data.bookBrokerList.forEach(br => {
              br.bookList.forEach(b => {
                headers[0].push(this.getBookLabel(bookPnLMode))
                headers[1].push(br.name)
                headers[2].push(b)
              })
            })

            data.bookBrokerList.forEach(br => {
              if (col + br.bookList.length - 1 > col) {
                merges.push(columns[col] + '2:' + columns[col + br.bookList.length - 1] + '2')
              }
              col += br.bookList.length
            })
            if (col - 1 > start) {
              merges.push(columns[start] + '1:' + columns[col - 1] + '1')
            }

            // Total Books
            headers[0].push(this.$t('Total Books'))
            headers[1].push(this.$t('Total Books'))
            headers[2].push(this.$t('Total Books'))         

            merges.push(columns[col] + '1:' + columns[col] + '3')
            col++

            // Hedging
            data.hedgingBrokerList.forEach(br => {
              br.bookList.forEach(b => {
                headers[0].push(this.$t('Hedging'))
                headers[1].push(br.name)
                headers[2].push(b)
              })
            })

            let startHedging = col
            data.hedgingBrokerList.forEach(br => {
              if (col + br.bookList.length - 1 > col) {
                merges.push(columns[col] + '2:' + columns[col + br.bookList.length - 1] + '2')
              }
              col += br.bookList.length
            })
            if (col -1 > startHedging) {
              merges.push(columns[startHedging] + '1:' + columns[col - 1] + '1')
            }

            // Hedging Percent
            if (bookPnLMode) {
              headers[0].push(this.$t('Hdg %'))
              headers[1].push(this.$t('Hdg %'))
              headers[2].push(this.$t('Hdg %'))         

              merges.push(columns[col] + '1:' + columns[col] + '3')
              col++
            }

            // Markup
            if (this.includeMarkupsVal && !bookPnLMode) {
              headers[0].push(this.$t('Markup'))
              headers[1].push(this.$t('Markup'))
              headers[2].push(this.$t('Markup'))         

              merges.push(columns[col] + '1:' + columns[col] + '3')
              col++
            }

            // Total
            headers[0].push(this.$t('Total'))
            headers[1].push(this.$t('Total'))
            headers[2].push(this.$t('Total'))

            merges.push(columns[col] + '1:' + columns[col] + '3')
            col++
          }

          // STP
          if (this.showSTP) {
            if (col + data.stpBrokerList.length > col) {
              merges.push(columns[col] + '1:' + columns[col + data.stpBrokerList.length] + '1')
            }
            data.stpBrokerList.forEach(s => {
              headers[0].push(this.getSTPLabel(bookPnLMode))
              headers[1].push(s)
              headers[2].push(s)
              merges.push(columns[col] + '2:' + columns[col] + '3')
              col++
            })
            merges.push(columns[col] + '2:' + columns[col] + '3')
            col++

            headers[0].push(this.getSTPLabel(bookPnLMode))
            headers[1].push(this.$t('Total'))
            headers[2].push(this.$t('Total'))
          }

          let tableData = []
          data.tableData.forEach(row => {
            let thisRow = []
            thisRow.push(row.instrumentName)
            if (this.showBook) {
              data.bookBrokerList.forEach(br => {
                br.bookList.forEach(b => {
                  if (row.book[br.name]) {
                    thisRow.push(row.book[br.name][b])
                  }
                  else {
                    thisRow.push('0.00')
                  }
                })
              })

              thisRow.push(row.bookTotal)

              data.hedgingBrokerList.forEach(br => {
                br.bookList.forEach(b => {
                  if (row.hedging[br.name]) {
                    thisRow.push(row.hedging[br.name][b])
                  }
                  else {
                    thisRow.push('0.00')
                  }
                })
              })

              if (bookPnLMode)
                thisRow.push(row.hedgingPercent)

              if (this.includeMarkupsVal && !bookPnLMode)
                thisRow.push(row.markupAmount)

              thisRow.push(row.total)
            }

            if (this.showSTP) {
              data.stpBrokerList.forEach(s => {
                thisRow.push(row.stp[s])
              })
              thisRow.push(row.stp.total)
            }

            tableData.push(thisRow)
          })

          sheetList.push({
            multiHeader: headers,
            data: tableData,
            merges: merges,
            sheetName: this.getExcelSheetName(bookPnLMode)
          })
        }

        if (sheetOnly) {
          // return sheetList
          return {
            isMultiTab: true,
            tabList: sheetList
          }
        } else {
          let filename = this.panel.exportExcelFilePrefix + '_' +  timestamp()

          excel.export_json_to_excel_lusis_multisheet({
            filename: filename,
            autoWidth: true,
            bookType: 'xlsx',
            sheets: sheetList
          })
        }
      })
    },
    getDetail: function (label,row,column) {
      let currentCol = this.getColumn(column.id)
      let dataKeys = []
      let platform = ""
      let bookName = ""
      if (currentCol && currentCol.hasOwnProperty('$attrs')) {
        dataKeys = currentCol.$attrs.dataKeys
      }
    
      if (dataKeys!==null && dataKeys!==undefined) {
        if (dataKeys[0] === 'book' && dataKeys.length>=3) {
          platform = dataKeys[1]
          bookName = dataKeys[2]
        }
      }

      let params = [
        {'paramName': 'origin', 'paramValue': this.panel.id},
        {'paramName': 'symbol', 'paramValue': label}
      ]
      this.$emit('getDetail', {title: this.panel.options.title, type: 'symbol', value: label, params: params, show: true, platform: platform, bookName: bookName})
    }
  }
}
</script>

<style lang='scss'>
.el-drawer.rtl {
  overflow: visible;
  animation: none !important;
}

.handle-button-close {
  width: 48px;
  height: 48px;
  position: absolute;
  opacity: .8;
  top: 50%;
  left: -48px;
  transform: translateY(-50%);
  text-align: center;
  font-size: 24px;
  border-radius: 6px 0 0 6px !important;
  z-index: 1111110;
  pointer-events: auto;
  cursor: pointer;
  line-height: 48px;
  i {
    font-size: 24px;
    line-height: 48px;
  }
}

.tooltip {
      padding: 3px;
  }

  .tooltip .itemTitle{
    padding: 3px;
  }

  .tooltip  .itemValue{
    padding: 3px;
    text-align: right;
    justify-content:  flex-end;
  }
</style>